import React from "react";
import AdminCard from "./adminCard";
import "./delivered.css";

const Delivered = ({ ordersFound, data, handleStatusClick, handleDeliveryClick, handleChef, handleChefPenality, handleComment, handleRefund }) => {
  const handleOrder = (orderID) => {
    window.open(`/order?orderID=${orderID}`, "_blank");
  };

  return (
    <div className="delivered">
      {ordersFound ? (
        data.map((data, id) => (
          <AdminCard
            id={id}
            data={data}
            handleOrder={handleOrder}
            handleChef={handleChef}
            status="DELIVERED"
            handleStatusClick={handleStatusClick}
            handleDeliveryClick={handleDeliveryClick}
            handleChefPenality={handleChefPenality}
            handleComment={handleComment}
            handleRefund={handleRefund}
          />
        ))
      ) : (
        <h1>No Delivered Orders Found</h1>
      )}
    </div>
  );
};

export default Delivered;
